const refs = {
  body: document.querySelector('body'),
  header: document.querySelector('header'),
  loader: document.querySelector('.loader'),
};
export default refs;